<template>
  <div class="container">
    <cw-header v-if="isheader" class="header" />
    <router-view class="view" />
    <div class="poster">
      <img
        :src="poster"
        style="vertical-align: middle"
        alt="华运昌微信公众号"
        class="poster-img"
      />
    </div>
    <cw-bottom />
    <el-image
      src="https://www.eroadshipping.com/img/2022/03/08/gzh_code.gif"
      class="gzh"
    ></el-image>
  </div>
</template>

<script>
import bottom from '../../components/Bottom/bottom'
import header from '../../components/Header/header'

export default {
  name: 'Container',
  components: {
    cwBottom: bottom,
    cwHeader: header
  },
  data() {
    return {
      isheader: true,
      poster: require('@/assets/images/poster/poster.jpg')
    }
  },
  created() {
    // console.log(this.$route.path)
  }
}
</script>

<style scoped>
.container {
  /*position: relative;*/
  height: 100%;
}

.header {
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 10;
}

.poster-img {
  width: 100%;
}

.gzh {
  position: fixed;
  left: 0;
  bottom: 80px;
  display: block;
  height: 150px;
  width: 200px;
}
</style>
